<template>
    <header class="container_header">
        <div class="header_navigation">
            <div class="container_sub">
                <div class="sub_content left">
                    <div class="logo">
                        <Logo />
                    </div>
                </div>
                <div class="content4 right">
                    <div v-if="currentSection != 'conciliador'" @click="() => openLastDocuments()"
                        class="user_info_border_header px-3">
                        <Bell v-if="!hasNewDocs" />
                        <BellNotification v-else />
                    </div>
                    <div :class="['actions', { 'invisible_actions': !isDropdownOpen }]" ref="loginMenu">
                        <UserMenu :user="user" />
                    </div>
                    <div class="dropdown user_info_border_header">
                        <div class="contrast_border" @click="toggleLoginMenu()">
                            <div class="company_logo_div">
                                <img :src="user.logo" class="company_logo" v-if="user.logo" />
                            </div>
                            <div class="circle">
                                <Avatar class="avatar_icon" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column_navigation middle" v-if="user.user_info_loaded">
                <div class="row_navigation">
                    <div v-if="user.has_conciliator" @mousedown="setSection('conciliador')"
                        :class="['tab_bordered', { 'nav_item_base': currentSection != 'conciliador' }, { 'nav_item_base_selected': currentSection == 'conciliador' }]">
                        <div class="sub_content">
                            <div class="text">Conciliación Bancaria
                            </div>
                        </div>
                    </div>
                    <div v-if="user.has_classificator" @mousedown="setSection('accounts_plan')"
                        :class="['tab_bordered', { 'nav_item_base': currentSection != 'accounts_plan' }, { 'nav_item_base_selected': currentSection == 'accounts_plan' }]">
                        <div class="sub_content">
                            <div class="text">Plan de Cuentas</div>
                        </div>
                    </div>
                    <div v-if="user.has_classificator" @mousedown="setSection('classificator')"
                        :class="['tab_bordered', { 'nav_item_base': currentSection != 'classificator' }, { 'nav_item_base_selected': currentSection == 'classificator' }]">
                        <div class="sub_content">
                            <div class="text">Clasificador de Documentos</div>
                        </div>
                    </div>
                    <div v-if="user.has_financial_report" @mousedown="setSection('reports')"
                        :class="['tab_bordered', { 'nav_item_base': currentSection != 'reports' }, { 'nav_item_base_selected': currentSection == 'reports' }]">
                        <div class="sub_content">
                            <div class="text">Reporte Financiero</div>
                        </div>
                    </div>
                    <div v-if="user.has_file_upload" @mousedown="setSection('fileUpload')"
                        :class="['tab_bordered', { 'nav_item_base': currentSection != 'fileUpload' }, { 'nav_item_base_selected': currentSection == 'fileUpload' }]">
                        <div class="sub_content">
                            <div class="text">Subir Data</div>
                        </div>
                    </div>
                    <div v-if="user.has_embedded_report" @mousedown="setSection('reporte')"
                        :class="['tab_bordered', { 'tab_header_is_totally_grey': !chartLoaded }, { 'nav_item_base': currentSection != 'reporte' }, { 'nav_item_base_selected': currentSection == 'reporte' }]">
                        <div class="sub_content">
                            <div class="text">Reporte Financiero</div>
                        </div>
                    </div>
                    <div v-if="user.has_financiamiento" @mousedown="setSection('financiamiento')"
                        :class="['tab_bordered', { 'nav_item_base': currentSection != 'financiamiento' }, { 'nav_item_base_selected': currentSection == 'financiamiento' }]">
                        <div class="sub_content">
                            <div class="text">Financiamiento</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import '@fontsource/inter/400.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/900.css';

import BodyLastDocuments from "@/components/classification/lastDocuments/BodyLastDocuments";
import HeaderLastDocuments from "@/components/classification/lastDocuments/HeaderLastDocuments";
import UserMenu from "@/components/dashboard/UserMenu";
import ModalFullHeightRight from "@/components/modals/ModalFullHeightRight";
import Avatar from "@/components/svg/Avatar.vue";
import Bell from "@/components/svg/Bell.vue";
import BellNotification from "@/components/svg/BellNotification.vue";
import Logo from "@/components/svg/Logo.vue";
import config from "@/config";
import router from "@/router";
import { getSession } from "@/utils/auth";
import { BASIC, CLASSIC } from "@/utils/clientTypes";
import { mapActions, mapState } from "vuex";

export default {
    name: "Header",
    components: {
        Logo,
        Avatar,
        UserMenu,
        Bell,
        BellNotification,
    },
    data() {
        return {
            clicksEnabled: false,
            hostBackend: "",
            modalDefault: {
                parent: this,
                hasModalCard: true,
                customClass: "modal-class",
                canCancel: ["escape", "outside"],
            },
            BASIC,
            CLASSIC,
            selectedSection: 'none',
            isDropdownOpen: false,
            has_multiple_tabs: false,
        };
    },
    props: {
        currentSection: String,
        chartLoaded: Boolean,
    },
    methods: {
        ...mapActions("userAuth", [
            "clearUserInfo",
            "setLoginInfo",
            "deleteSelf",
            "getUserInfo",
        ]),
        ...mapActions("classification", ["getIfHasNewDocs"]),
        toggleLoginMenu() {
            this.isDropdownOpen = !this.isDropdownOpen;
            if (this.isDropdownOpen) {
                setTimeout(() => document.addEventListener('click', this.handleClickOutsideLoginMenu), 1);
            } else {
                document.removeEventListener('click', this.handleClickOutsideLoginMenu);
            }
        },
        handleClickOutsideLoginMenu(event) {
            const loginMenu = this.$refs.loginMenu;
            if (loginMenu && !loginMenu.contains(event.target)) {
                this.isDropdownOpen = false;
                document.removeEventListener('click', this.handleClickOutsideLoginMenu);
            }
        },
        moreThanOneTrue(...args) {
            let trueCount = args.reduce((count, value) => count + (value === true ? 1 : 0), 0);
            return trueCount > 1;
        },
        goToLink(url) {
            window.location.href = url;
        },
        setSection(section) {
            if (this.clicksEnabled) {
                this.selectedSection = section;
                this.$emit('change-section', section);
            }
        },
        getCompanyIdFromHashUrl() {
            const hash = window.location.hash;
            const queryString = hash.includes('?') ? hash.split('?')[1] : '';
            const params = new URLSearchParams(queryString);
            return params.get('company_id') || null;
        },
        openLastDocuments() {
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: ModalFullHeightRight,
                customClass: "classify_modal_width",
                props: {
                    headerComp: HeaderLastDocuments,
                    bodyComp: BodyLastDocuments,
                    headerProps: null,
                    bodyProps: null,
                },
                events: {
                },
            });
        }
    },
    computed: {
        ...mapState("userAuth", ["user"]),
        ...mapState("classification", ["hasNewDocs"]),
    },
    created() {
        let session = getSession();
        if (session) {
            this.setLoginInfo(session);
            const company_id = this.getCompanyIdFromHashUrl();
            this.getUserInfo(session.user.email, company_id);
        } else {
            this.clearUserInfo();
            router.push("/");
        }
        if (this.user.is_superuser) this.hostBackend = config.baseApi;
        this.getIfHasNewDocs()
    },
    watch: {
        chartLoaded(newValue) {
            if (newValue) {
                this.clicksEnabled = true;
            }
        },
        user(newValue) {
            if (newValue.user_info_loaded) {
                this.has_multiple_tabs = this.moreThanOneTrue(this.user.has_conciliator, this.user.has_embedded_report, this.user.has_file_upload, this.user.has_classificator);
            }
        },
    }
};
</script>
<style scoped>
.container_header {
    margin-left: clamp(10px, 5.5vw, 90px);
    margin-right: clamp(10px, 5.5vw, 90px);
}

.tab_header_is_totally_grey {
    color: #dddddd !important;
    filter: blur(0.5px);
}


.logo {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    width: 142px;
    position: relative;
    height: 32px;
    margin-bottom: 25px;
}


.text {
    position: relative;
    line-height: 24px;
}

.nav_item_base {
    height: 32px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    color: #98a2b3;
    padding: 8px 8px;
    border-left: 1px solid #eaecf0;
    margin-left: -1px;
}

.nav_item_base_selected {
    border-bottom: 2px solid #0d5154;
    box-sizing: border-box;
    height: 32px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding-left: 8px;
    padding-right: 8px;
    color: #0d5154;
}

.tab_bordered {
    border-left: 1px solid #eaecf0;
    margin-left: -1px;
    white-space: nowrap;
    cursor: pointer;
    user-select: none;
}

.row_navigation>.tab_bordered:first-of-type,
.row_navigation>.nav_item_base_selected:first-of-type {
    border-left: none;
    margin-left: 0;
}

.nav_item_base_selected .text {
    font-weight: 600;
}

.column_navigation {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 100%;
}

@media (max-width: 800px) {
    .row_navigation {
        transform: scale(0.9);
        position: relative;
    }
}

@media (max-width: 600px) {
    .row_navigation {
        display: flex;
        flex-direction: column !important;
        position: relative;
        top: 60px;
    }

    .header_navigation,
    .container_sub,
    .container_header {
        height: 160px;
    }

    .row_navigation>.tab_bordered,
    .row_navigation>.nav_item_base_selected {
        border-left: none;
        margin-left: 0;
    }

}

@media (max-width: 500px) {
    .row_navigation {
        top: 100px;
    }

    .header_navigation,
    .container_sub,
    .container_header {
        height: 180px;
    }
}

.row_navigation {
    display: flex;
    align-items: stretch;
    flex-direction: row;
    justify-content: flex-start;
    gap: 0px;
}

.wide_menu {
    width: 400px !important;
}

.actions {
    position: fixed;
    top: 65px;
    right: 0px;
    width: 260px;
    height: 200px;
    z-index: 200;
    /* opacity: 100%; */
    transition: height 0.15s ease, opacity 0.15s ease;
}

.invisible_actions {
    opacity: 0%;
    height: 0;
    display: none;
}

.circle {
    min-width: 40px;
    width: 40px;
    max-width: 40px;
    min-height: 40px;
    height: 40px;
    max-height: 40px;
    background-color: #F2F4F7;
    border: 2px solid #D1D5DB;
    border-radius: 50%;
    z-index: 2;
    text-align: center;
}

.avatar_icon {
    width: 100%;
    position: relative;
    border-radius: 200px;
    height: 24px;
    top: 5px;
    z-index: 2;
}

.container_sub {
    width: 100%;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
}

.sub_content {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-grow: 1;
}

.content4 {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
}

.user_info_border_header {
    cursor: pointer;
    border: 1px solid #EAECF0;
    border-radius: 10px;
    min-height: 50px;
    padding: 4px;
    display: flex;
    align-items: center;
}

.company_logo_div {
    display: flex;
    align-items: center;
    justify-content: center;
}

.middle {
    display: flex;
    margin-left: auto;
    margin-right: auto;
}

.header_navigation {
    width: 100%;
    position: relative;
    background-color: #fff;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    font-size: 16px;
    color: #344054;
    font-family: Inter, "Open Sans", sans-serif;
}


.contrast_border {
    display: flex;
    flex-direction: row;
}

.company_logo {
    max-height: 40px;
    max-width: 100px;
    margin-right: 5px;
    object-fit: contain;
}
</style>
